import { render, staticRenderFns } from "./TopupChannelPage.vue?vue&type=template&id=7aaf2442&scoped=true&"
import script from "./TopupChannelPage.vue?vue&type=script&lang=js&"
export * from "./TopupChannelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf2442",
  null
  
)

export default component.exports